import ClientErrorMessage from "@/components/shared/ClientErrorMessage";
import * as Sentry from "@sentry/react";
import React from "react";
import {
	createRoutesFromChildren,
	matchRoutes,
	Routes,
	useLocation,
	useNavigationType,
	useRouteError,
} from "react-router";

export function initSentry() {
	Sentry.init({
		dsn: "https://49b86e2783495c73ca6da1f9754646fa@o4506745663979520.ingest.us.sentry.io/4509825092026369",
		// Setting this option to true will send default PII data to Sentry.
		// For example, automatic IP address collection on events
		sendDefaultPii: true,
		integrations: [
			Sentry.reactRouterV7BrowserTracingIntegration({
				useEffect: React.useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes,
			}),
			Sentry.replayIntegration(),
		],
		// Tracing
		tracesSampleRate: 1.0, //  Capture 100% of the transactions
		// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
		tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
		// Session Replay
		replaysSessionSampleRate: 0, // This sets the sample rate at 0%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
		// Logs
		enableLogs: true,
	});
}

export const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);

export function SentryRootErrorBoundary() {
	const error = useRouteError() as Error;

	React.useEffect(() => {
		Sentry.captureException(error);
	}, [error]);

	return <ClientErrorMessage message="Something went wrong!" />;
}
